{
  "GENERAL": {
    "CLOSE": "Zatvori",
    "SHOWING_RESULTS": "Showing {firstIndex}-{lastIndex} of {totalCount} items",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Traži",
      "EMPTY_STATE": "Ništa nije pronađeno"
    }
  },
  "TAG_INPUT": {
    "MIN_TAGS_REQUIRED": "Potrebno je najmanje {count}"
  }
}
